import React from 'react';
import Spacing from '../../Spacing';
import SectionHeading from '../../SectionHeading';
import Team from '../../Team';

export default function TeamSection({ sectionTitle, sectionTitleUp, data }) {
  const isSingle = data?.length === 1;

  return (
    <div className="container  lg:mt-[0]">
      <SectionHeading title={sectionTitle} titleUp={sectionTitleUp} center />
      <Spacing md="72" lg="50" />
      <div
        className={`w-[90%] mx-auto  ${
          isSingle ? 'flex justify-center' : 'md:grid grid-cols-2 flex flex-wrap justify-evenly gap-8 '
        }`}
      >
        {data?.map((item, index) => (
          <div key={index}>
            <Team {...item} />
          </div>
        ))}
      </div>
    </div>
  );
}
